import { SystemStyleObject } from "@chakra-ui/react";

export const accountCardGrid: SystemStyleObject = {
    display: "grid",
    gridTemplateColumns: { base: "1fr", md: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" },
    gap: 4,
}

export const accountCard: SystemStyleObject = {
    p: 5,
    bg: "#F9F9F9",
    borderRadius: 16,
    cursor: "pointer",
    textDecoration: "none !important",
    display: "flex",
    flexDirection: "column",
    gap: 3,
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
    _hover: {
        transform: "translateY(-2px)",
        boxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.08), 0px 2px 6px 0px rgba(0, 0, 0, 0.12)",
    },
}

export const invitationCard: SystemStyleObject = {
    p: 5,
    bg: "#F0FAF2",
    borderRadius: 16,
    cursor: "pointer",
    textDecoration: "none !important",
    display: "flex",
    flexDirection: "column",
    gap: 3,
    border: "1px solid",
    borderColor: "#1EC84333",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
    _hover: {
        transform: "translateY(-2px)",
        boxShadow: "0px 4px 12px 0px rgba(30, 200, 67, 0.12), 0px 2px 6px 0px rgba(30, 200, 67, 0.08)",
    },
}

export const invitationBadge: SystemStyleObject = {
    px: 2,
    py: 0.5,
    borderRadius: 4,
    bg: "#1EC84320",
    border: "1px solid",
    borderColor: "#1EC84355",
}

export const pendingBadge: SystemStyleObject = {
    px: 2,
    py: 0.5,
    borderRadius: 6,
    fontSize: "xs",
    fontWeight: 600,
}

/**
 * Looping glow pulse for newly discovered invitations.
 * Plays continuously until the user navigates away (component unmounts).
 * On return the glow is gone because the invitation is marked as "seen".
 */
export const invitationGlow: SystemStyleObject = {
    "@keyframes invitationPulse": {
        "0%, 100%": { boxShadow: "0 0 0 0 rgba(30, 200, 67, 0)" },
        "50%": { boxShadow: "0 0 18px 6px rgba(30, 200, 67, 0.3)" },
    },
    animation: "invitationPulse 2s ease-in-out infinite",
}

/**
 * Single glow pulse for transactions transitioning to "Executing" state.
 * Uses the Executing status colour (green).
 */
export const executingGlow: SystemStyleObject = {
    "@keyframes executingPulse": {
        "0%": { boxShadow: "0 0 0 0 rgba(56, 161, 105, 0)" },
        "30%": { boxShadow: "0 0 16px 5px rgba(56, 161, 105, 0.3)" },
        "100%": { boxShadow: "0 0 0 0 rgba(56, 161, 105, 0)" },
    },
    animation: "executingPulse 2s ease-in-out",
    borderRadius: 8,
}

/**
 * Single glow pulse for transactions transitioning to "Scheduled" state.
 * Uses the Scheduled status colour (blue).
 */
export const scheduledGlow: SystemStyleObject = {
    "@keyframes scheduledPulse": {
        "0%": { boxShadow: "0 0 0 0 rgba(49, 130, 206, 0)" },
        "30%": { boxShadow: "0 0 16px 5px rgba(49, 130, 206, 0.3)" },
        "100%": { boxShadow: "0 0 0 0 rgba(49, 130, 206, 0)" },
    },
    animation: "scheduledPulse 2s ease-in-out",
    borderRadius: 8,
}

/**
 * Single glow pulse for newly created transactions.
 * Uses the "Waiting" status colour (orange).
 * Plays once over 2 seconds then stops.
 */
export const newTransactionGlow: SystemStyleObject = {
    "@keyframes newTxPulse": {
        "0%": { boxShadow: "0 0 0 0 rgba(237, 137, 54, 0)" },
        "30%": { boxShadow: "0 0 16px 5px rgba(237, 137, 54, 0.3)" },
        "100%": { boxShadow: "0 0 0 0 rgba(237, 137, 54, 0)" },
    },
    animation: "newTxPulse 2s ease-in-out",
    borderRadius: 8,
}
